import { createReducer } from '../utils/createReducer'
import {request} from "../utils/request";

const namespace = 'session';

const initialState = {
  userinfo: {},
  backgroundImageList: [],
  background: '',
};



const reducer = {
  getUserinfo(state = initialState, action){

    console.log('action->', action)

    return {...state, userinfo: action.result}
  },
  delete(state = initialState, action){

  },
  getBackground(state = initialState, action){
    console.log(action)
    const theme = action.result && action.result.theme;

    return {...state, background: theme? theme: require('../assets/bg/zto/zto_7.jpg')}
  }
};

export default createReducer(initialState, reducer, namespace);


export function exit() {
  return {
    type: 'session/delete',
    // promise: request(`${global.ssoCfg.endPoint}/session`,{method: 'delete'})
  }
}

export function changeBackground(action) {
  return {
    type: 'session/onChangeBackground',
    promise: request('/theme', { method: 'post', form: true, body: action}),
    action
  }
}








// WEBPACK FOOTER //
// ./src/reducers/session.js